var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.errorMessage
        ? _c(
            "div",
            { staticClass: "alert alert-danger", attrs: { role: "alert" } },
            [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.validationError.length > 0
        ? _c(
            "div",
            { staticClass: "alert alert-danger", attrs: { role: "alert" } },
            [
              _c("span", [_vm._v(" Your password must contains : ")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.validationError, function(reg, index) {
                  return _c("li", { key: index }, [
                    _vm._v("\n          " + _vm._s(reg) + "\n        ")
                  ])
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.successMessage
        ? _c(
            "div",
            { staticClass: "alert alert-success", attrs: { role: "alert" } },
            [_vm._v("\n      " + _vm._s(_vm.successMessage) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-body pt-1" }, [
        _c("div", { staticClass: "row row__inline" }, [
          _c("div", { staticClass: "col-12 col-sm-6 mb-1" }, [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "account-old-password" }
              },
              [_vm._v("Current password")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__password" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.oldPassword,
                    expression: "oldPassword"
                  }
                ],
                staticClass: "form-control input__password",
                attrs: {
                  type: "password",
                  placeholder: "Enter current password"
                },
                domProps: { value: _vm.oldPassword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.oldPassword = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cursor__pointer", on: { click: _vm.showHide } },
                [
                  _c("i", {
                    staticClass: "fa fa-eye-slash",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-6 mb-1" }, [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "account-new-password" }
              },
              [_vm._v("New Password")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__password" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPassword,
                    expression: "newPassword"
                  }
                ],
                staticClass: "form-control input__password",
                attrs: { type: "password", placeholder: "Enter new password" },
                domProps: { value: _vm.newPassword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newPassword = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cursor__pointer", on: { click: _vm.showHide } },
                [
                  _c("i", {
                    staticClass: "fa fa-eye-slash",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-sm-6 mb-1" }, [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "account-retype-new-password" }
              },
              [_vm._v("Retype New Password")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form__password" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.confirmPassword,
                    expression: "confirmPassword"
                  }
                ],
                staticClass: "form-control input__password",
                attrs: {
                  type: "password",
                  placeholder: "Confirm your new password"
                },
                domProps: { value: _vm.confirmPassword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.confirmPassword = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cursor__pointer", on: { click: _vm.showHide } },
                [
                  _c("i", {
                    staticClass: "fa fa-eye-slash",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn__save",
                attrs: { type: "button" },
                on: { click: _vm.save }
              },
              [_vm._v("\n            Save changes\n          ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn__discard",
                attrs: { type: "button" },
                on: { click: _vm.reset }
              },
              [_vm._v("\n            Discard\n          ")]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "card-body py-2 my-25" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", [
          _c(
            "button",
            {
              staticClass: "btn btn__delete",
              attrs: { type: "button" },
              on: { click: _vm.deleteAccount }
            },
            [_vm._v("\n          Deactivate Account\n        ")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header border-bottom" }, [
      _c("h4", { staticClass: "card-title" }, [_vm._v("Change Password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", { staticClass: "fw-bolder" }, [_vm._v("Password requirements:")]),
      _vm._v(" "),
      _c("ul", { staticClass: "ps-1 ms-25" }, [
        _c("li", { staticClass: "mb-50" }, [
          _vm._v(
            "\n              Minimum 8 characters long - the more, the better\n            "
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mb-50" }, [
          _vm._v("At least one lowercase character")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("At least one number, symbol, or whitespace character")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header border-bottom" }, [
      _c("h4", { staticClass: "card-title" }, [_vm._v("Delete Account")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-warning" }, [
      _c("h4", { staticClass: "alert-heading" }, [
        _vm._v(
          "\n          Are you sure you want to delete your account?\n        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alert-body fw-normal" }, [
        _vm._v(
          "\n          Once you delete your account, there is no going back. Please be\n          certain.\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80dc1b7e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80dc1b7e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user_profile/info/security.vue
// module id = null
// module chunks = 